var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51172 24.7708V22.1042C6.51172 21.3969 6.79267 20.7186 7.29277 20.2185C7.79286 19.7185 8.47114 19.4375 9.17839 19.4375H17.1784C17.8856 19.4375 18.5639 19.7185 19.064 20.2185C19.5641 20.7186 19.8451 21.3969 19.8451 22.1042V24.7708",
    stroke: "#232222",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1797 14.7246C15.3888 14.7246 17.1797 12.9337 17.1797 10.7246C17.1797 8.51547 15.3888 6.72461 13.1797 6.72461C10.9705 6.72461 9.17969 8.51547 9.17969 10.7246C9.17969 12.9337 10.9705 14.7246 13.1797 14.7246Z",
    stroke: "#232222",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.513 1.39062H3.84635C2.37359 1.39062 1.17969 2.58512 1.17969 4.05859V22.7344C1.17969 24.2079 2.37359 25.4023 3.84635 25.4023H22.513C23.9858 25.4023 25.1797 24.2079 25.1797 22.7344V4.05859C25.1797 2.58512 23.9858 1.39062 22.513 1.39062Z",
    stroke: "#232222",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactus);
export default __webpack_public_path__ + "static/media/contactus.0f9ea5a41421f71325900c28ccb91533.svg";
export { ForwardRef as ReactComponent };